module.exports = __webpack_public_path__ + "img/11.955c420c.png";